import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [message, setMessage] = useState("Processing...");
  const [txnid, setTxnid] = useState("");
  const [orderUniqueId, setOrderUniqueId] = useState(""); // State to store the order unique ID
  const [countdown, setCountdown] = useState(10); // Countdown timer state

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const txn = queryParams.get("txnid");

    if (txn) {
      setTxnid(txn);
      console.log("txn", txn);

      axios
        .post(`${baseurl}markPaymentAsSuccess`, { txnid: txn }) // ✅ Correct success API
        .then((res) => {
          console.log("Response from backend:", res.data);
          setMessage("Your payment was successful!");
          setOrderUniqueId(res.data.order.order_unique_id); // Set the order unique ID from response

          // Countdown timer logic
          const timer = setInterval(() => {
            setCountdown((prev) => {
              if (prev <= 1) {
                clearInterval(timer); // Stop the timer when it reaches 0
                navigate(`/performa-invoice/${res.data.order.order_unique_id}`); // Navigate to the invoice page
                return 0;
              }
              return prev - 1;
            });
          }, 1000); // Decrease countdown every second
        })
        .catch((err) => {
          console.error("Payment success update error:", err.response?.data || err.message);
          setMessage("There was an issue confirming your payment status.");
        });
    } else {
      setMessage("Invalid or missing transaction ID.");
    }
  }, [location.search, navigate]);

  return (
    <>
      <VisitorNavbar />
      <div className="container py-5">
        <h4 className="hesd mb-4 text-start">Payment Gateway</h4>
        <div className="row">
          <div className="col-md-6 offset-md-3 text-center">
            <div className="success-icon mb-3">
              <span>&#10004;</span>
            </div>
            <h5 className="text-success">{message}</h5>
            {txnid && (
              <p className="mt-2">
                <strong>Transaction ID:</strong> {txnid}
              </p>
            )}
            {orderUniqueId && (
              <p className="mt-3">
                <strong>Your order is being processed. You will be redirected to the invoice in {countdown} seconds.</strong>
              </p>
            )}
            <a href="/" className="btn btn-outline-success mt-3">
              Return to Home
            </a>
          </div>
        </div>
      </div>
      <Footer />
      <style>{`
        .success-icon {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background-color: #d4edda;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          font-size: 48px;
          color: #28a745;
          box-shadow: 0 0 10px rgba(40, 167, 69, 0.3);
        }
      `}</style>
    </>
  );
};

export default PaymentSuccess;
